import React from 'react'

import SurveyIntegrationContentAndImageLayout from 'components/SurveyIntegrationContentAndImageLayout'
import ActivateIntegrationButtonSection from 'components/ActivateIntegrationButtonSection'
/**
 * @param {object} props
 * @param {(IntegrationSetting) => void} props.onChange
 * @param {boolean} props.loading
 * @param {boolean} props.isAuthenticated
 * @param {boolean} props.isIntegrationActive
 */
export default function UpdateTagIntegration({
  onChange,
  loading,
  isAuthenticated,
  isIntegrationActive,
}) {
  function activateIntegration() {
    onChange({
      name: 'push_tag',
      isActive: true,
    })
  }

  function deactivateIntegration() {
    onChange({
      name: 'push_tag',
      isActive: false,
    })
  }

  return (
    <SurveyIntegrationContentAndImageLayout
      imageUrl="https://cdn.simplesat.io/intercom/add-tags-to-rated-conversations.png"
      imageDescription="Add tags to rated conversations"
    >
      <div className="mb-4">
        <p>Two tags will be added to the conversation after a rating is given:</p>
        <ul className="!mt-0">
          <li>Sentiment - Positive, Neutral, or Negative.</li>
          <li>Rating - 0-10 depending on the rating scale and metric used.</li>
        </ul>
        <p>
          <em>
            Note: Tags will not be visible in conversations when the latest message is an internal
            note.
          </em>
        </p>
        <a
          href="https://help.simplesat.io/en/articles/5230032-intercom-integrations#h_7e1fce59a2"
          target="_blank"
          rel="noreferrer"
        >
          <i className="icon far fa-book" />
          Learn more about adding tags to rated conversations
        </a>
      </div>
      <ActivateIntegrationButtonSection
        activateIntegration={activateIntegration}
        deactivateIntegration={deactivateIntegration}
        loading={loading}
        isAuthenticated={isAuthenticated}
        isIntegrationActive={isIntegrationActive}
        integrationType="Intercom"
      />
    </SurveyIntegrationContentAndImageLayout>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomInAppPublish/UpdateTagIntegration.js